import GetOrganisationListRequestModelBase from '../_generated/modelBases/get-organisation-list-request-model-base';

export default class GetOrganisationListRequestModel extends GetOrganisationListRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
